export function resetEventLoop<T>(f: () => T): Promise<T> {
  return new Promise((res) => setTimeout(() => res(f()), 0));
}

export function sleep(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}
